package frontend.modals

import CurrencySelect
import androidx.compose.runtime.*
import net.sergeych.ugdx.shared.ApiException
import net.sergeych.ugdx.shared.Currency
import components.TButton
import components.TForm
import components.TTextInput
import frontend.App
import frontend.components.Modal
import frontend.lib.classList
import frontend.models.User
import frontend.pages.Wallet
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun CreateAccountModal(app: App, user: User, onClose: () -> Unit) {
    val scope = rememberCoroutineScope()
    var name: String? by mutableStateOf(null)
    val defaultCurrency = app.currencies.filter { it.canCreateAccount }.firstOrNull()
    var currency: Currency? by mutableStateOf(defaultCurrency)
    var error: String? by mutableStateOf(null)

    fun createAccount(currency: Currency?, name: String?) {
        error = when {
//            name == null -> "Name cannot be empty"
            currency == null -> "Select currency"
            else -> {
                val existing = user.accounts.find {
                    it.currencyCode == currency.code && it.name == name
                }
                if (existing != null) "Account with this name and currency already exists"
                else {
                    scope.launch {
                        try {
                            if (name != null) user.createAccount(currency, name)
                            else user.createAccount(currency)
                            onClose()
                        } catch(err: ApiException) {
                            error = err.message
                        }
                    }
                    null
                }
            }
        }
    }

    Modal(onClose = { onClose() }) {
        TForm() {
            H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
                Text("Create account")
            }

            CurrencySelect("currency", currency) {
                label { Text("Select currency") }
                onChange { currency = it }
                filter { it.canCreateAccount }
            }

            TTextInput("name", name ?: "") {
                label { Text("Account name") }
                onInput {
                    if (it == "") name = null
                    else name = it
                }
            }

            if (error !== null) P(attrs = { classes("text-red-600") }) {
                Text(error ?: "")
            }

            TButton(attrs = {
                onClick { createAccount(currency, name) }
            }) {
                Text("Create account")
            }
        }
    }
}